import { render, staticRenderFns } from "./competitorMatchLost.vue?vue&type=template&id=6e5f763b"
import script from "./competitorMatchLost.vue?vue&type=script&lang=js"
export * from "./competitorMatchLost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports